var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { AXSBlock } from '@axs/axsui-axsblock';
var Div = styled(AXSBlock)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-content: ", ";\n  align-items: ", ";\n  display: flex;\n  flex-direction: ", ";\n  ", ";\n  ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"], ["\n  align-content: ", ";\n  align-items: ", ";\n  display: flex;\n  flex-direction: ", ";\n  ", ";\n  ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"])), function (_a) {
    var alignContent = _a.alignContent;
    return alignContent;
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems;
}, function (_a) {
    var flexDirection = _a.flexDirection;
    return flexDirection;
}, function (_a) {
    var flexGap = _a.flexGap;
    return "gap: " + flexGap;
}, function (_a) {
    var flexFlow = _a.flexFlow;
    return "flex-flow: " + flexFlow;
}, function (_a) {
    var flexWrap = _a.flexWrap;
    return flexWrap;
}, function (_a) {
    var justifyContent = _a.justifyContent;
    return (justifyContent ? justifyContent : 'flex-start');
});
export var AXSFlex = function (_a) {
    var backgroundColor = _a.backgroundColor, className = _a.className, props = __rest(_a, ["backgroundColor", "className"]);
    return (React.createElement(Div, __assign({}, props, { backgroundColor: backgroundColor, className: classnames(['c-axs-flex', className]) }), props.children));
};
var templateObject_1;
